import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { PackageIcon } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useRbac } from "@/lib/rbac";

export const FGBF_ROUTE = "/admin/maintenance/fg-backfill";

// Shown only to Administrators when the server confirms the tool is enabled (GET status → 200).
export function FgBackfillNavEntry({ collapsed }) {
  const { administrator, ready } = useRbac();
  const [ok, setOk] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!ready || !administrator) return;
    api.get("/admin/fg-backfill/status").then(() => setOk(true)).catch(() => setOk(false));
  }, [ready, administrator]);
  if (!ok) return null;
  const active = pathname.startsWith(FGBF_ROUTE);
  return (
    <NavLink to={FGBF_ROUTE} data-testid="nav-fg-backfill" title={collapsed ? "FG Historical Backfill" : undefined}
      className={`mt-1 flex items-center gap-3 ${collapsed ? "justify-center px-2" : "px-3"} py-2 rounded-sm text-sm border border-transparent transition-colors ${
        active ? "bg-[var(--bg-2)] text-white shadow-[inset_2px_0_0_0_#f59e0b]" : "text-zinc-300 hover:text-white hover:bg-[var(--bg-2)]/60"}`}>
      <PackageIcon size={15} weight={active ? "fill" : "regular"} className={active ? "text-amber-400" : "text-zinc-500"} />
      {!collapsed && <span className="truncate">FG Historical Backfill</span>}
    </NavLink>
  );
}
